import PropTypes from 'prop-types';
import React, { useMemo } from 'react';

import '@fontsource/roboto';
import Typography from '@mui/material/Typography/Typography';
import { styled } from '@mui/material/styles';
import { visuallyHidden } from '@mui/utils';
import classnames from 'classnames';
import HTMLReactParser from 'html-react-parser';

const ScreenReaderOnly = styled(Typography)({
  ...visuallyHidden,
});

const MaterialTypography = (props) => {
  const {
    className,
    children,
    component,
    color,
    align,
    variant = 'body1',
    srOnly = false,
    enableFocus,
    ...rest
  } = props;

  return useMemo(
    () =>
      !srOnly ? (
        <Typography
          className={classnames(MaterialTypography.displayName, className)}
          variant={variant}
          component={component}
          color={color}
          align={align}
          tabIndex={enableFocus ? 0 : undefined}
          {...rest}
        >
          {typeof children === 'string' ? HTMLReactParser(children) : children}
        </Typography>
      ) : (
        <ScreenReaderOnly variant={variant} component={component} {...rest}>
          {typeof children === 'string' ? HTMLReactParser(children) : children}
        </ScreenReaderOnly>
      ),
    [variant, align, color, component, children, className],
  );
};

MaterialTypography.propTypes = {
  children: PropTypes.node.isRequired,
  variant: PropTypes.oneOf([
    'body1',
    'body2',
    'button',
    'caption',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'inherit',
    'overline',
    'subtitle1',
    'subtitle2',
  ]),
};

MaterialTypography.displayName = 'MaterialTypography';

export default React.memo(MaterialTypography);
